import { lazy } from 'react';

import { RoleVariantEnum } from 'common/graphql/types';
export const routes = [
    {
        component: lazy(() => import('module/subscriber/SubscribersListPage')),
        permissions: ['Subscriber_Create'],
        role: [RoleVariantEnum.SystemAdministrator],
        path: '/',
    },
];
